import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger, Glyphicon } from 'react-bootstrap'
import RecurrentEntityModalPage from '../../../containers/masters/recurrentEntity/RecurrentEntityModalPage'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import InputSelect from '../../commons/form/InputSelect'
import ModalMassUploadPage from '../../../containers/masters/ModalMassUpload/ModalMassUploadPage'
import { loadTemplatesNames, entityTypesId } from '../../../constants/backendIds'
import { EntityType } from '../../../constants/dossier/common/entityTypes'
import UserRecurrrentEntityModalPage from '../../../containers/masters/recurrentEntity/UserRecurrrentEntityModalPage'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class RecurrentEntityAdmin extends PureComponent {
  constructor () {
    super()
    this.state = {
      recurrentEntityTypeCombo: null,
      filter: {
        searchName: null,
        searchDniCif: null,
        searchClientNumber: null,
        searchUO: [],
        searchEntityTypeId: null,
        searchEntitySubTypeId: null,
        includeOU: true
      },
      showModal: false,
      searchClicked: false
    }
  }

  componentDidMount () {
    // this.searchRecurrentEntity()
    this.props.actions.fetchOrganizedUnitsAcceptClientsCombo()
    this.props.actions.fetchEntitySubTypesList()
    this.setState({
      recurrentEntityTypeCombo: [
        { id: EntityType.RECURRING, value: this.props.t('ADMIN.RECURRENT_ENTITY_TYPE') },
        { id: EntityType.RECURRING_SERVICE, value: this.props.t('ADMIN.RECURRENT_SERVICE_ENTITY_TYPE') }]
    })
  }

  componentDidUpdate () {
    if (this.props.ouIdFromMaster != null) {
      if (!this.state.filter.searchUO.some(x => x.toString() === this.props.ouIdFromMaster.toString())) {
        this.setState({ filter: { ...this.state.filter, searchUO: [this.props.ouIdFromMaster.toString()] } })
      }
      this.props.actions.setChangeTabFromMaster(null, false)
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchRecurrentEntityList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchRecurrentEntityList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleNameChange (searchName) {
    if (this.state.filter.searchName !== searchName) {
      this.setState({ filter: { ...this.state.filter, searchName } })
    }
  }

  handleDniCifChange (searchDniCif) {
    if (this.state.filter.searchDniCif !== searchDniCif) {
      this.setState({ filter: { ...this.state.filter, searchDniCif } })
    }
  }

  handleClientNumberChange (searchClientNumber) {
    if (this.state.filter.searchClientNumber !== searchClientNumber) {
      this.setState({ filter: { ...this.state.filter, searchClientNumber } })
    }
  }

  handleOrganizedUnitChange (searchUO) {
    if (!searchUO || searchUO.length === 0) {
      this.setState({ filter: { ...this.state.filter, searchUO: [] } })
      return
    }
    const searchUoList = searchUO.split(',').map((item) => {
      return parseInt(item)
    })
    if (this.state.filter.searchUO !== searchUoList) {
      this.setState({ filter: { ...this.state.filter, searchUO: searchUoList } })
    }
  }

  handleEntityTypeChange (searchEntityTypeId) {
    if (this.state.filter.searchEntityTypeId !== searchEntityTypeId) {
      this.props.change('filters.entitySubTypeId', null)
      setTimeout(() => { this.setState({ filter: { ...this.state.filter, searchEntityTypeId: searchEntityTypeId, searchEntitySubTypeId: null } }) }, 100)
    }
  }

  handleEntitySubTypeChange (searchEntitySubTypeId) {
    if (this.state.filter.searchEntitySubTypeId !== searchEntitySubTypeId) {
      this.setState({ filter: { ...this.state.filter, searchEntitySubTypeId: searchEntitySubTypeId } })
    }
  }

  searchRecurrentEntity () {
    this.props.actions.fetchRecurrentEntityList({ ...this.props.filter, ...this.state.filter, page: 1 })
    this.setState({ searchClicked: true })
  }

  closeRecEntModalLoad () {
    this.setState({ showModal: false })
  }

  openRecEntModalLoad () {
    this.setState({ showModal: true })
    this.props.actions.openModalMass('ADMIN.RECURRENT_ENTITIES.MODAL_MASS_UPLOAD.', this.props.actions.uploadRecEntMassDocument, this.searchRecurrentEntity.bind(this))
  }

  openModal (entityId) {
    const entity = this.props.entityList.filter(x => x.entityId === entityId)[0]
    if (entity.countryCode) {
      if (entity.stateCode) {
        this.props.actions.fetchEntityStateTypeCombo(this.props.combos.entityCountryTypeCombo?.find(x => x.code === entity.countryCode)?.id)
        if (entity.cityCode) {
          this.props.actions.fetchEntityCityTypeCombo(this.props.combos.entityStateTypeCombo?.find(x => x.code === entity.stateCode)?.id)
          if (entity.townCode) {
            this.props.actions.fetchEntityTownTypeCombo(this.props.combos.entityCityTypeCombo?.find(x => x.code === entity.cityCode)?.id)
            if (entity.colonyCode) {
              this.props.actions.fetchEntityColonyTypeCombo(this.props.combos.entityTownTypeCombo?.find(x => x.code === entity.townCode)?.id)
              this.props.actions.fetchEntityCPTypeCombo(this.props.combos.entityColonyTypeCombo?.find(x => x.code === entity.colonyCode)?.id)
            }
          }
        }
      } else {
        this.props.actions.fetchEntityCPTypeCombo(-1)
        this.props.actions.fetchEntityStateTypeCombo(-1)
        this.props.actions.fetchEntityCityTypeCombo(-1)
        this.props.actions.fetchEntityTownTypeCombo(-1)
        this.props.actions.fetchEntityColonyTypeCombo(-1)
      }
    }
    this.props.actions.openEditRecurrentEntityModal(entityId)
  }

  editUserServiceEntity (entityId, filters) {
    this.props.actions.openCloseUserRecurrentServiceModal(true, entityId)
  }

  resetFilters () {
    this.props.initialize({})
    this.props.reset()
    this.setState({
      filter: {
        searchClientNumber: null,
        searchDniCif: null,
        searchEntitySubTypeId: null,
        searchEntityTypeId: null,
        searchUO: []
      }
    })
  }

  render () {
    const {
      t, entityList, pagesCount, filter, entityCount, recurrentEntitySubTypesList,
      filter: { page },
      combos: { UOTreeCombo },
      actions: { openAddRecurrentEntityModal, fetchRecurrentEntityList, deleteRecurrentEntity, fetchTemplateFile }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'adminRecurrentEntitiesPage' })
    const tKey = 'ADMIN.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const userTooltip = (<Tooltip id="userTooltip">{t(`${tKey}USER_RECURRENT_SERVICE`)}</Tooltip>)
    const downloadTemplateTooltip = (<Tooltip id="userTooltip">{t('MASTERS.DOWNLOAD')}</Tooltip>)
    const fileTooltip = (<Tooltip id="userTooltip">{t(`${tKey}RECURRENT_ENTITIES.MODAL_MASS_UPLOAD.UPLOAD_DOCUMENT`)}</Tooltip>)
    const hasFilters = (this.state.filter.searchClientNumber || this.state.filter.searchDniCif || this.state.filter.searchName ||
      this.state.filter.searchEntitySubTypeId || this.state.filter.searchEntityTypeId || (this.state.filter.searchUO !== null && this.state.filter.searchUO.length > 0))

    return (
      <div id='recurrentEntityAdmin' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openAddRecurrentEntityModal()}>
              <i className='iDocIcon-add-plus'></i>{t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
            <OverlayTrigger placement="left" overlay={downloadTemplateTooltip}>
              <Button
                className="_Btn accent o-icn"
                onClick={() => fetchTemplateFile(loadTemplatesNames.recEntity)}
                onKeyDown={(e) => handleKeyDown(e)}>
                <i className='iDocIcon-download'></i>
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="left" overlay={fileTooltip}>
              <Button
                className="_Btn new o-icn"
                onClick={this.openRecEntModalLoad.bind(this)}
              >
                <i className='iDocIcon-file-excel' />
                <Glyphicon glyph="open-file" />{' ' + t('MASTERS.ADD')}
              </Button>
            </OverlayTrigger>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputTreeSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.organizedUnit"
                controlLabel={t(`${tKey}RECURRENT_ENTITIES.UO`)}
                placeholder={t(`${tKey}RECURRENT_ENTITIES.UO`)}
                multi={true}
                valueKey="value"
                labelKey="label"
                childrenKey="children"
                options={UOTreeCombo}
                colSm={4}
                onInputChange={(value) => this.handleOrganizedUnitChange(value)}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.entityTypeId"
                controlLabel={t(`${tKey}RECURRENT_ENTITIES.ENTITY_TYPE`)}
                placeholder={t(`${tKey}RECURRENT_ENTITIES.ENTITY_TYPE`)}
                multi={false}
                valueKey="id"
                labelKey="value"
                childrenKey="children"
                options={this.state.recurrentEntityTypeCombo}
                onInputChange={(value) => this.handleEntityTypeChange(value)}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.entitySubTypeId"
                controlLabel={t(`${tKey}RECURRENT_ENTITIES.ENTITY_SUB_TYPE`)}
                placeholder={t(`${tKey}RECURRENT_ENTITIES.ENTITY_SUB_TYPE`)}
                multi={false}
                valueKey="id"
                labelKey="value"
                childrenKey="children"
                options={recurrentEntitySubTypesList?.filter(x => x.mode === this.state.filter.searchEntityTypeId)}
                onInputChange={(value) => this.handleEntitySubTypeChange(value)}
                disabled={!this.state.filter.searchEntityTypeId}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="name"
                name="filters.name"
                controlLabel={t(`${tKey}RECURRENT_ENTITIES.NAME`)}
                placeholder={t(`${tKey}RECURRENT_ENTITIES.NAME`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="dniCif"
                name="filters.dniCif"
                controlLabel={t(`${tKey}RECURRENT_ENTITIES.DNICIF`)}
                placeholder={t(`${tKey}RECURRENT_ENTITIES.DNICIF`)}
                onInputChange={(value) => this.handleDniCifChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchRecurrentEntity()}>
                  <i className="iDocIcon-search"/>
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer' + (this.state.maxiTable ? ' maxiTable' : '')}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              { entityCount > 0 &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th style={{ display: 'none' }} onClick={() => { this.changeOrder('code') }}>
                        {t(`${tKey}RECURRENT_ENTITIES.CODE`)}&nbsp;
                        <i className={this.getSortIcon('code')} />
                      </th>
                      <th onClick={() => { this.changeOrder('name') }}>
                        {t(`${tKey}RECURRENT_ENTITIES.NAME`)}&nbsp;
                        <i className={this.getSortIcon('name')} />
                      </th>
                      <th onClick={() => { this.changeOrder('dnicif') }}>
                        {t(`${tKey}RECURRENT_ENTITIES.DNICIF`)}&nbsp;
                        <i className={this.getSortIcon('dnicif')} />
                      </th>
                      <th onClick={() => { this.changeOrder('ou') }}>
                        {t(`${tKey}RECURRENT_ENTITIES.UO`)}&nbsp;
                        <i className={this.getSortIcon('ou')} />
                      </th>
                      <th>{t(`${tKey}RECURRENT_ENTITIES.TYPE`)}</th>
                      <th>{t(`${tKey}RECURRENT_ENTITIES.SUB_TYPE`)}</th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {entityList && entityList.map((recurrentEntity, idx) => {
                      return (
                        <tr key={idx} className=''>
                          <td style={{ display: 'none' }}>{recurrentEntity.entityId}</td>
                          <td>{recurrentEntity.name}</td>
                          <td>{recurrentEntity.dniCif}</td>
                          <td>{recurrentEntity.organizedUnitName}</td>
                          <td>{
                            recurrentEntity.entityTypeId && this.state.recurrentEntityTypeCombo &&
                          this.state.recurrentEntityTypeCombo.find((value, idx) => { return value.id === recurrentEntity.entityTypeId }) &&
                          (this.state.recurrentEntityTypeCombo.find((value, idx) => { return value.id === recurrentEntity.entityTypeId }).value)
                          }</td>
                          <td>{
                            recurrentEntity.entitySubTypeId && recurrentEntitySubTypesList &&
                          recurrentEntitySubTypesList.find((value, idx) => { return value.id === recurrentEntity.entitySubTypeId }) &&
                          (recurrentEntitySubTypesList.find((value, idx) => { return value.id === recurrentEntity.entitySubTypeId }).value)
                          }</td>
                          <td className='actions'>
                            <div>
                              { (recurrentEntity.entityTypeId === entityTypesId.recurrentService) && (
                                <></>
                              )}

                              { (recurrentEntity.entityTypeId === entityTypesId.recurrentService) && (
                                <OverlayTrigger placement="left" overlay={userTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => this.editUserServiceEntity(recurrentEntity.entityId, { ...filter, ...this.state.filter })}>
                                    <i className="iDocIcon-user-no-image-user-menu"/>
                                  </a>
                                </OverlayTrigger>
                              )
                              }
                              <OverlayTrigger placement="left" overlay={editTooltip}>
                                <a className='_Btn accept stk o-icn ' onClick={() => this.openModal(recurrentEntity.entityId)}>
                                  <i className="iDocIcon-edit" />
                                </a>
                              </OverlayTrigger>

                              { (recurrentEntity.canDelete) && (
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => deleteRecurrentEntity(recurrentEntity.entityId, { ...filter, ...this.state.filter })}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              )
                              }
                            </div>
                          </td>
                        </tr>)
                    })
                    }

                  </tbody>
                </Table>
              }

              {(this.state.searchClicked === true && (entityList === null || entityList === undefined || entityList.length === 0)) &&
                <p className="no_results" >{t('MASTERS.CUSTOM_FIELDS.RESULTS_NOT_FOUND')}</p>
              }
              <div className="section-recurrentEntities-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={entityCount}
                    onSelectAction={(value) => fetchRecurrentEntityList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <RecurrentEntityModalPage/>
        <UserRecurrrentEntityModalPage/>
        <ModalMassUploadPage
          showModal={this.state.showModal}
          closeModal={this.closeRecEntModalLoad.bind(this)}
          acceptZip={true}
        />
      </div>
    )
  }
}

export default reduxForm({
  form: 'listRecurrentEntity'
})(RecurrentEntityAdmin)
